import { CommonTermSheetInput } from '@/services/termSheet/schemas/common';
import { nanoid } from 'nanoid';

export const DISCLOSURE_DEFAULT_VALUE =
  "This is a private loan offered by a non-bank lender and may not be subject to the same consumer disclosures required under federal or state lending laws. Lender reserves the right to decline this financing at any time prior to execution of final documents, for any reason, including material changes in Borrower's representations, the underlying collateral, or market conditions. This offer is not a commitment to lend and is subject to completion of due diligence and execution of definitive agreements. Borrower acknowledges that this is a business-purpose loan and not intended for personal, family, or household use.";

export const getCommonDefaultValues = ({
  transactionType
}: {
  transactionType: CommonTermSheetInput['purpose'];
}) => ({
  purpose: transactionType || 'purchase',
  cashAtClosing: [
    { label: 'Origination Fee', value: undefined, id: nanoid() },
    { label: 'Processing Fee', value: undefined, id: nanoid() }
  ],
  disclosure: DISCLOSURE_DEFAULT_VALUE
});
